import graphql from './graphql';

const query = /* GraphQL */ `
  query User_list_developmentPlan(
    $name: String
    $department: String
    $terminal: String
    $jobTitle: String
    $startDate: Date
    $endDate: Date
    $limit: Int
    $offset: Int!
  ) {
    User_list_developmentPlan(
      name: $name
      department: $department
      terminal: $terminal
      jobTitle: $jobTitle
      startDate: $startDate
      endDate: $endDate
      limit: $limit
      offset: $offset
    ) {
      rows {
        fullName
        lastAssess
        Department {
          name
        }
        JobTitle {
          name
        }
        Terminal {
          name
        }
        pendingCourses
        totalCourses
      }
      count
    }
  }
`;

const UserListDevelopmentPlan = async attributes =>
  graphql(query, attributes)
    .then(data => data.User_list_developmentPlan)
    .catch(err => err);

export default UserListDevelopmentPlan;
